import { httpClient } from '../client';
import { logger } from '../../../utils/logger';
import { ApiErrorHandler } from '../error.handler';
import { BaseEndpoint } from './base.endpoint';
import {
  CreatedUnavailableDateResponse,
  GetUnavailableDatesResponse,
  UnavailableDate,
} from '../../../types/unavailable-dates';

class UnavailableDatesEndpoints extends BaseEndpoint {
  private static instance: UnavailableDatesEndpoints;

  private constructor() {
    super('organisations');
  }

  static getInstance(): UnavailableDatesEndpoints {
    if (!UnavailableDatesEndpoints.instance) {
      UnavailableDatesEndpoints.instance = new UnavailableDatesEndpoints();
    }
    return UnavailableDatesEndpoints.instance;
  }

  async createUnavailableDates(
    orgId: string,
    data: UnavailableDate
  ): Promise<CreatedUnavailableDateResponse> {
    try {
      const headers = await this.getAuthHeaders();
      const response = await httpClient.post<{ data: CreatedUnavailableDateResponse }>(
        `${this.basePath}/${orgId}/unavailable-dates`,
        data,
        { headers }
      );

      return response.data.data;
    } catch (error) {
      logger.error('Failed to create unavailable dates:', error);
      return ApiErrorHandler.handle(error);
    }
  }

  async getUnavailableDates(
    orgId: string,
    resourceId: string,
    startDate: string,
    endDate: string
  ): Promise<CreatedUnavailableDateResponse[]> {
    try {
      const headers = await this.getAuthHeaders();
      const response = await httpClient.get<GetUnavailableDatesResponse>(
        `${this.basePath}/${orgId}/unavailable-dates/resource/${resourceId}`,
        {
          headers,
          params: {
            startDate,
            endDate,
          },
        }
      );

      return response.data.data;
    } catch (error) {
      logger.error('Failed to fetch unavailable dates:', error);
      return ApiErrorHandler.handle(error);
    }
  }

  async deleteUnavailableDate(
    orgId: string,
    resourceId: string,
    bookedDate: string
  ): Promise<boolean> {
    try {
      const headers = await this.getAuthHeaders();
      const response = await httpClient.delete<{ message: string }>(
        `${this.basePath}/${orgId}/unavailable-dates/resource/${resourceId}`,
        {
          headers,
          params: {
            bookedDate,
          },
        }
      );

      // Optional: You can check the message to be safe
      return response.status === 200;
    } catch (error) {
      logger.error('Failed to delete unavailable date:', error);
      return ApiErrorHandler.handle(error);
    }
  }

  async deleteUnavailableDateById(orgId: string, unavailableDateId: number): Promise<boolean> {
    try {
      const headers = await this.getAuthHeaders();
      const response = await httpClient.delete<{ message: string }>(
        `${this.basePath}/${orgId}/unavailable-dates/${unavailableDateId}`,
        { headers }
      );

      return response.status === 200;
    } catch (error) {
      logger.error('Failed to delete unavailable date by ID:', error);
      return ApiErrorHandler.handle(error);
    }
  }
}

export const unavailableEndpoints = UnavailableDatesEndpoints.getInstance();
